import { EvmChainId } from 'sushi/evm'

export const KATANA_CHAIN_ID = EvmChainId.KATANA

export const EVM_UI_FEE_BIPS = 0
export const EVM_UI_FEE_PERCENT = EVM_UI_FEE_BIPS / 100
export const EVM_UI_FEE_DECIMAL = EVM_UI_FEE_BIPS / 10_000

export function getUiFeePercent(_chainId: number) {
  return EVM_UI_FEE_PERCENT
}

export type SwapApiEnabledChainId = typeof KATANA_CHAIN_ID
export const isSwapApiEnabledChainId = (
  chainId: number,
): chainId is SwapApiEnabledChainId => chainId === KATANA_CHAIN_ID

export const DISABLED_CHAIN_IDS = [] as const

export const NEW_CHAIN_IDS = [] as const

export const PREFERRED_CHAINID_ORDER = [KATANA_CHAIN_ID] as const

export const getSortedChainIds = <T extends number>(chainIds: readonly T[]) => {
  return [...chainIds]
}

export const CHAIN_IDS = [KATANA_CHAIN_ID] as const

export const AMM_SUPPORTED_CHAIN_IDS = [KATANA_CHAIN_ID] as const

export const SUPPORTED_CHAIN_IDS = [KATANA_CHAIN_ID] as const

export type SupportedChainId = (typeof SUPPORTED_CHAIN_IDS)[number]
export const isSupportedChainId = (
  chainId: number,
): chainId is SupportedChainId => chainId === KATANA_CHAIN_ID

export const SUPPORTED_NETWORKS = [KATANA_CHAIN_ID] as const

export const POOL_SUPPORTED_NETWORKS = [KATANA_CHAIN_ID] as const

export const ZAP_SUPPORTED_CHAIN_IDS = [KATANA_CHAIN_ID] as const

export type ZapSupportedChainId = (typeof ZAP_SUPPORTED_CHAIN_IDS)[number]
export const isZapSupportedChainId = (
  chainId: number,
): chainId is ZapSupportedChainId => chainId === KATANA_CHAIN_ID

export const XSWAP_SUPPORTED_CHAIN_IDS = [] as const

export type XSwapSupportedChainId = (typeof XSWAP_SUPPORTED_CHAIN_IDS)[number]

export const isXSwapSupportedChainId = (
  chainId: number,
): chainId is XSwapSupportedChainId => false
